module.exports = __webpack_public_path__ + "img/no-sensor-heading.1c9a820c.svg";